<template>
  <div class="navbar">
    <!-- :style="{
      background: configurationData.colorTheme
        ? configurationData.colorTheme
        : '#fff',
    }" -->
    <div>
      <router-link
        v-if="roles == 'user' || roles == 'admin'"
        to="/index"
        style="
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <img
          :src="
            configurationData.logoUrl
              ? url + configurationData.logoUrl
              : '/logo.png'
          "
          alt=""
          class="logo"
        />
      </router-link>
      <div
        style="
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <img
          v-if="roles != 'user' && roles != 'admin'"
          :src="
            configurationData.logoUrl
              ? url + configurationData.logoUrl
              : '/logo.png'
          "
          alt=""
          class="logo"
        />
      </div>
    </div>
    <div class="middle-menu">
      <el-scrollbar
        ref="scrollRef"
        wrap-class="scrollbar-wrapper"
        hide-scrollbar
        @wheel.native="handleWheel"
      >
        <template v-if="appStore.device !== 'mobile'">
          <el-menu
            class="nav-container"
            :default-active="activeMenu"
            text-color="#333"
            :active-text-color="'#FF830E'"
            :collapse-transition="false"
            :mode="
              configurationData &&
              configurationData.menuConfig != '' &&
              configurationData.menuConfig != null &&
              configurationData.menuConfig != undefined
                ? configurationData.menuConfig
                : 'horizontal'
            "
            :ellipsis="false"
            :background-color="
              configurationData &&
              configurationData.colorTheme &&
              configurationData.colorTheme != '' &&
              configurationData.colorTheme != null &&
              configurationData.colorTheme != undefined
                ? configurationData.colorTheme
                : '#fff'
            "
          >
            <sidebar-item
              v-for="(route, index) in sidebarRouters"
              :key="route.path + index"
              :item="route"
              :base-path="route.path"
            />
          </el-menu>
        </template>
      </el-scrollbar>
    </div>
    <div class="right-menu">
      <div class="avatar-container">
        <el-dropdown
          @command="handleCommand"
          class="right-menu-item hover-effect"
          trigger="click"
        >
          <div class="avatar-wrapper">
            <img
              :src="
                userStore.avatar != null
                  ? url + userStore.avatar
                  : '/defaultAvatar.png'
              "
              class="user-avatar"
            />
            <div>{{ userStore.name }}</div>
            <img
              src="/xiala.png"
              alt=""
              style="width: 0.875rem; height: 0.875rem; margin-left: 0.625rem"
            />
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <!-- <router-link
                to="/pc/usercenter"
                v-if="roleId == 100 || roleId == 'admin'"
              >
                <el-dropdown-item>用户中心</el-dropdown-item>
              </router-link> -->
              <router-link to="/user/profile">
                <el-dropdown-item>个人中心</el-dropdown-item>
              </router-link>
              <!-- <el-dropdown-item
                command="setLayout"
                v-if="settingsStore.showSettings"
              >
                <span>布局设置</span>
              </el-dropdown-item> -->
              <el-dropdown-item divided command="logout">
                <span>退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { ElMessageBox } from "element-plus";
import SidebarItem from "../Sidebar/SidebarItem.vue";
import useAppStore from "@/store/modules/app";
import useUserStore from "@/store/modules/user";
import useSettingsStore from "@/store/modules/settings";
import usePermissionStore from "@/store/modules/permission";
import useBusinessTodoStore from "@/store/modules/businessTodo";

const url = ref(import.meta.env.VITE_APP_BASE_API + "/file/download/?fileId=");
const props = defineProps({
  configurationData: Object,
});

const route = useRoute();
const appStore = useAppStore();
const userStore = useUserStore();
const roles = computed(() => Array.isArray(userStore.roles) ? userStore.roles[0] || "" : "");
const settingsStore = useSettingsStore();
const permissionStore = usePermissionStore();
const businessTodoStore = useBusinessTodoStore();
const sidebarRouters = computed(() => permissionStore.sidebarRouters);
const roleId = ref("");

onMounted(() => {
  businessTodoStore.refresh();
});

watch(
  () => route.fullPath,
  () => {
    businessTodoStore.refresh(true);
  }
);

const scrollRef = ref(null);
let scrollContainer = null; // 存储滚动容器DOM

function toggleSideBar() {
  appStore.toggleSideBar();
}

function handleCommand(command) {
  switch (command) {
    case "setLayout":
      setLayout();
      break;
    case "logout":
      logout();
      break;
    default:
      break;
  }
}

function logout() {
  ElMessageBox.confirm("确定注销并退出系统吗？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    cancelButtonClass: "colent",
    confirmButtonClass: "search_for",
    type: "warning",
  })
    .then(() => {
      userStore.logOut().then(() => {
        location.href = "/index";
      });
    })
    .catch(() => {});
}

const emits = defineEmits(["setLayout"]);
function setLayout() {
  emits("setLayout");
}

function toggleTheme() {
  settingsStore.toggleTheme();
}
function getRole() {
  roleId.value = userStore.rolesData?.roles?.[0]?.roleId || "";
}
const activeMenu = computed(() => {
  const { meta, path } = route;
  if (meta.activeMenu) {
    return meta.activeMenu;
  }
  return path;
});
// 组件挂载后，获取实际滚动的DOM容器
onMounted(() => {
  if (scrollRef.value) {
    // 通过自定义的wrap-class找到滚动容器
    scrollContainer = scrollRef.value.$el.querySelector(".scrollbar-wrapper");
    // 初始化滚动位置
    if (scrollContainer) {
      scrollContainer.scrollLeft = 0;
    }
  }
});
// 处理滚轮事件
const handleWheel = (e) => {
  if (!scrollContainer) return; // 确保容器存在

  e.preventDefault(); // 阻止默认纵向滚动
  // 直接操作DOM的scrollLeft实现横向滚动
  scrollContainer.scrollLeft += e.deltaY * 0.5; // 0.5为滚动速度系数
};
setTimeout(() => {
  getRole();
}, 500);
</script>

<style lang='scss' scoped>
.navbar {
  height: 100%;
  overflow: hidden;
  position: relative;
  background: var(--navbar-bg);
  box-shadow: 0px 2px 4px 0px rgba(51, 51, 51, 0.06);
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1;

  .logo {
    width: 6.238184928894043rem;
    height: 2.0625rem;
    margin-left: 2.5rem;
    height: 2.0625rem;
    margin-top: 1.3125rem;
    margin-bottom: 1.375rem;
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .middle-menu {
    width: auto;
    max-width: 80%;
    float: left;
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    align-items: center;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: var(--navbar-text);
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }

      &.theme-switch-wrapper {
        display: flex;
        align-items: center;

        svg {
          transition: transform 0.3s;

          &:hover {
            transform: scale(1.15);
          }
        }
      }
    }

    .waybill-container {
      font-weight: 400;
      font-size: 1rem;
      display: flex;
      align-items: center;
      margin: 0 1.25rem;
      height: 100%;
    }
    .waybill-container .moreServices {
      font-weight: 400;
      font-size: 1rem;
      color: #000;
      line-height: 1;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .avatar-container {
      margin-right: 40px;
      display: flex;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .user-avatar {
          cursor: pointer;
          width: 1.75rem;
          height: 1.75rem;
          border-radius: 50%;
          margin-right: 0.625rem;
        }

        i {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
    .nav-container {
      width: 100%;
      height: 100%;
      ::v-deep .el-sub-menu {
        width: 100%;
        height: 100%;
      }
    }

    ::v-deep .el-menu {
      border: none;
      height: 100%;
      width: 100% !important;
      background: #fff;

      .el-menu-item {
        color: #000;
        background: #fff;
        &.is-active {
          color: #fff !important;
          background: #ff830e !important;
        }
        &.is-active:hover {
          background: #ff830e !important;
        }
      }

      .el-sub-menu__title {
        background: #fff;
      }
    }
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    align-items: center;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: var(--navbar-text);
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }

      &.theme-switch-wrapper {
        display: flex;
        align-items: center;

        svg {
          transition: transform 0.3s;

          &:hover {
            transform: scale(1.15);
          }
        }
      }
    }

    .waybill-container {
      font-weight: 400;
      font-size: 1rem;
      display: flex;
      align-items: center;
      margin: 0 1.25rem;
      height: 100%;
    }
    .waybill-container .moreServices {
      font-weight: 400;
      font-size: 1rem;
      color: #000;
      line-height: 1;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .avatar-container {
      margin-right: 40px;
      display: flex;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .user-avatar {
          cursor: pointer;
          width: 1.75rem;
          height: 1.75rem;
          border-radius: 50%;
          margin-right: 0.625rem;
        }

        i {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
.loginButton {
  width: 6.125rem;
  height: 2rem;
  background-color: #ff830e;
  border: none;
  border-radius: 4px;
  color: #fff;
}
::v-deep .scrollbar-wrapper {
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
}
::v-deep .el-dropdown-menu__item:not(.is-disabled):focus,
::v-deep .el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: rgba(255, 131, 14, 0.1);
  color: #ff830e;
}
#app .sidebar-container {
  width: 15rem !important;
  border: 1px solid #f3f3f3;
  background: #fff;
  -webkit-box-shadow: none !important;
}
#app .sidebar-container .el-menu-item,
#app .sidebar-container .menu-title {
  color: #000;
}
::v-deep.el-menu-item.is-active {
  color: #fff !important;
  background: #ff830e !important;
}
</style>
